import React, {useMemo} from "react";
import {DataGridColumnAlignments, DataGridColumnPinnedTypes, DataGridColumnTypes, useDataGridSavedState} from "../../../../../../packages/data-grid";
import PartnerDataGrid from "../../../../../containers/data-grid";
import {PayMultiInvoicesDialogInvoicesDataGridColumnNames} from "../../../../../../core/constants/table/data-grid-column-keys";
import PartnerIndustryRules from "../../../../../../core/services/partner-industry-rules";
import {usePartnerInformation} from "../../../../../hooks/use-partner-information";
import CacheService from "../../../../../../core/services/cache/cache_service";

const dataGridSaveConfig = {
    name: 'PayMultiInvoicesDialogInvoicesSectionDataGrid',
    version: 1,
}

const PayMultiInvoicesDialogInvoicesSection = ({selectedInvoices}) => {
    const partnerInformation = usePartnerInformation();
    const partnerId = useMemo(() => partnerInformation?.id ?? CacheService.getOperatorPartnerId(), [partnerInformation?.id]);

    const columns = useMemo(() =>
        /**@type {DataGridColumn[]}*/
        [
            {
                title: 'Invoice No',
                name: PayMultiInvoicesDialogInvoicesDataGridColumnNames.invoiceNo,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                width: 120,
                pinned: true,
                sortable: false,
            },
            {
                title: 'Customer',
                name: PayMultiInvoicesDialogInvoicesDataGridColumnNames.customer,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                title: 'Submit Date',
                name: PayMultiInvoicesDialogInvoicesDataGridColumnNames.submitDate,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.date,
                sortable: false,
            },
            {
                title: 'Po-Number',
                name: PayMultiInvoicesDialogInvoicesDataGridColumnNames.poNo,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                title: 'Sales Person',
                name: PayMultiInvoicesDialogInvoicesDataGridColumnNames.salesPerson,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                title: 'Total',
                name: PayMultiInvoicesDialogInvoicesDataGridColumnNames.total,
                alignment: DataGridColumnAlignments.right,
                type: DataGridColumnTypes.money,
                sortable: false,
                pinned: true,
                pinnedType: DataGridColumnPinnedTypes.right,
            },
            {
                title: 'Balance',
                name: PayMultiInvoicesDialogInvoicesDataGridColumnNames.balance,
                alignment: DataGridColumnAlignments.right,
                type: DataGridColumnTypes.money,
                sortable: false,
                pinned: true,
                pinnedType: DataGridColumnPinnedTypes.right,
            },
        ], [])

    const [dataGridColumns, , , dataGridDensity] = useDataGridSavedState({
        columns: columns,
        name: dataGridSaveConfig.name,
        version: dataGridSaveConfig.version,
    });

    /**@type {DataGridRow[]}*/
    const dataGridRows = useMemo(() => {
        return selectedInvoices.map(invoice => ({
            key: invoice.id,
            data: invoice,
            cells: {
                [PayMultiInvoicesDialogInvoicesDataGridColumnNames.invoiceNo]: invoice.invoiceNo,
                [PayMultiInvoicesDialogInvoicesDataGridColumnNames.customer]: invoice.customer?.name,
                [PayMultiInvoicesDialogInvoicesDataGridColumnNames.submitDate]: invoice.invoiceDate,
                [PayMultiInvoicesDialogInvoicesDataGridColumnNames.poNo]: invoice.customerPO,
                [PayMultiInvoicesDialogInvoicesDataGridColumnNames.salesPerson]: invoice.salespersonNo,
                [PayMultiInvoicesDialogInvoicesDataGridColumnNames.total]: invoice.total,
                [PayMultiInvoicesDialogInvoicesDataGridColumnNames.balance]: PartnerIndustryRules.effectiveRemainingBalance(invoice, partnerId),
            },
        }))
    }, [selectedInvoices, partnerId])

    return (
        <div className='w-100'>
            <div className={'w-100 d-flex px-4'}>
                <p className={'text-sm text-color-2'}>
                    The following are your selected invoices to pay for. Do you wish
                    to <span className={'text-sm font-weight-bold black'}>continue</span> ?
                </p>
            </div>
            <PartnerDataGrid
                {...dataGridSaveConfig}
                initialLayoutState={{
                    columns: columns,
                }}
                columns={dataGridColumns}
                rows={dataGridRows}
                hideExporting
                hideFooter
                visibleRows={5}
                state={{
                    density: dataGridDensity,
                }}
            />
        </div>
    );
}

export default PayMultiInvoicesDialogInvoicesSection;
